import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import {
  AccordionDetails,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { sectionNames } from 'src/components/QueryMenus/checklistQueriesData';
import { QueryMenus } from 'src/components/QueryMenus/QueryMenus';
import { SectionQueryIndication } from 'src/components/QueryMenus/sectionQueryIndication';
import { useQueryMenus } from 'src/components/QueryMenus/useQueryMenus';
import { ViewQuery } from 'src/components/QueryMenus/ViewQuery/ViewQuery';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { pink } from '@mui/material/colors';
import moment from 'moment';
import Loader from 'src/components/common/Loader';
import { SERVER_DATE_FORMAT } from 'src/constants/formats';
import { clearMessage, setMessage } from 'src/store/Message';
import { ISIVReportClinicalTrialData } from 'src/types/SIVReport';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  IClinicalTrialMandatory,
  ISIVReportMandatory,
  ISIVReportModifiedKeys,
  ISIVReportModifiedKeysOfKeys,
  MandatoryData
} from './useSivReport';
import { setIsSaveButtonDisable } from 'src/store/sivReport';
const NOTES_MAXLENGTH = 2000;
const errorText = 'Required';

export interface IClinicalTrialDetails {
  clinicalTrialData: ISIVReportClinicalTrialData;
  updateClinicalData: (data: ISIVReportClinicalTrialData) => void;
  getSivReportData: (key: ISIVReportModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  isUpdate: boolean;
  isChange: boolean;
  setIsChange: (step: ISIVReportModifiedKeys, key: ISIVReportModifiedKeysOfKeys, val: boolean) => void;
  updateSIVReportMandatoryData: (key: keyof ISIVReportMandatory, value: MandatoryData) => void;
  mandatory: IClinicalTrialMandatory;
  sivReportSavedId: string;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}

const ClinicalTrialDetails: React.FunctionComponent<IClinicalTrialDetails> = ({
  getSivReportData,
  saveDisable,
  clinicalTrialData,
  updateClinicalData,
  isUpdate,
  setIsChange,
  isChange,
  mandatory,
  updateSIVReportMandatoryData,
  sivReportSavedId,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const user = useUser();
  const { sivcDataUpdateSuccessMsg, sivcMendatoryInfoErrorMsg, reportClinicalTrailDetails } = useFieldTranslation();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_siv_checklist');
  const [protocolVersion, setProtocolVersion] = useState<any>('');
  const [refreshKey, setRefreshKey] = useState(0);
  const selectedRowData: any = useAppSelector(state => state.sivReport.selectedRowData);
  const isSivReportCopyOverrideData: any = useAppSelector(state => state.sivCheckList.isSivReportCopyOverrideData);
  const saveButtonDisable: any = useAppSelector(state => state.sivReport.disableSaveButtonProps);
  const [recentData, setRecentData] = useState({ data: {}, mandatoryValidation: {} });

  const handleClinicalTrialData = (e: any) => {
    dispatchApp(clearMessage());
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const value = formattedVal;
    if (e.target.type === 'radio' && value === 'Y') {
      updateClinicalData({
        ...clinicalTrialData,
        siv_checklist_protocol_version_num:
          clinicalTrialData.siv_checklist_protocol_version_num?.toString() == 'x.xx'
            ? null
            : clinicalTrialData.siv_checklist_protocol_version_num,
        [e.target.name as keyof ISIVReportClinicalTrialData]: value,
        // [`${e.target.name}_comm` as keyof ISIVReportClinicalTrialData]: '',
        siv_report_pharmacy_tour: 'NA'
      });
      updateSIVReportMandatoryData('clinicalTrialDetails', { ...mandatory, [e.target.name]: false });
    } else if (e.target.type === 'radio') {
      updateClinicalData({
        ...clinicalTrialData,
        [e.target.name as keyof ISIVReportClinicalTrialData]: value,
        siv_report_pharmacy_tour: 'NA'
      });
      updateSIVReportMandatoryData('clinicalTrialDetails', { ...mandatory, [e.target.name]: false });
    }
    if (saveButtonDisable && e.target.type === 'radio') {
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, clinicalTrialDetails: false }));
    }
    setConfirmExitValue(dispatch, true);
  };

  const handleChange = (e: any) => {
    if (e.target.type !== 'radio') {
      const val = e.target.value;
      const formattedVal = typeof val === 'string' ? formatInput(val) : val;
      const value = formattedVal;
      setRecentData({
        data: {
          ...recentData.data,
          [e.target.name as keyof ISIVReportClinicalTrialData]: value,
          siv_report_pharmacy_tour: 'NA'
        },
        mandatoryValidation: { ...recentData.mandatoryValidation, [e.target.name]: false }
      });
    }
    if (saveButtonDisable) {
      dispatch(setIsSaveButtonDisable(false));
      setIsChange('Step1', 'clinicalTrialDetails', true);
    }
  };
  useEffect(() => {
    if (Object.keys(recentData.data).length) {
      updateClinicalData({
        ...clinicalTrialData,
        ...recentData.data
      });
      updateSIVReportMandatoryData('clinicalTrialDetails', { ...mandatory, ...recentData.mandatoryValidation });
    }
  }, [recentData.data]);

  const setValidationData = () => {
    const copyValidation = { ...mandatory };
    for (const key of Object.keys(copyValidation)) {
      if (
        clinicalTrialData[key as keyof ISIVReportClinicalTrialData] === 'N' &&
        !(
          clinicalTrialData[`${key}_comm` as keyof ISIVReportClinicalTrialData] &&
          clinicalTrialData[`${key}_comm` as keyof ISIVReportClinicalTrialData] !== null &&
          clinicalTrialData[`${key}_comm` as keyof ISIVReportClinicalTrialData] !== ''
        )
      ) {
        if (!key.includes('siv_report_protocol_version')) {
          copyValidation[key as keyof IClinicalTrialMandatory] = true;
        }
      } else {
        copyValidation[key as keyof IClinicalTrialMandatory] = false;
      }
    }
    updateSIVReportMandatoryData('clinicalTrialDetails', copyValidation);
    return copyValidation;
  };

  const [isSubmit, setIsSubmit] = useState(false);

  const { getPreferredDateInLocal } = usePreferedDateFormat();

  /* Updating Actual Check in date -- End*/

  const updateClinicalTrialData = async () => {
    setIsSubmit(true);
    const validate = setValidationData();
    if (Object.values(validate).indexOf(true) !== -1) {
      return dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }

    const chekboxFields = [
      'siv_report_ip_intact',
      'siv_report_ip_secure',
      'siv_report_ip_storage_csp',
      'siv_report_ip_temp',
      'siv_report_refrigerator_callibration',
      'siv_report_refrigerator_notification',
      'siv_report_pharmacy_binder',
      'siv_report_pharmacist_training',
      'siv_report_irt_access',
      'siv_report_pharmacist_da_log',
      'siv_report_ip_handling_subject',
      'siv_report_report_ip_compliants',
      'siv_report_ip_return',
      'siv_report_ip_destruction_site',
      'siv_report_emergency_unblinding',
      'siv_report_maintain_blinding'
    ];
    let clonedObj: any = clinicalTrialData;
    Object.keys(clonedObj).forEach(function (key: any) {
      if (chekboxFields.includes(key) && clonedObj[key] == '') {
        clonedObj = { ...clonedObj, [key]: 'NA' };
      }
    });

    if (clonedObj.siv_checklist_protocol_version_num == '' || clonedObj.siv_checklist_protocol_version_num == 'x.xx') {
      delete clonedObj.siv_checklist_protocol_version_num;
    }
    if (checkedInStartDate) {
      clonedObj.siv_visit_date = moment(checkedInStartDate).format(SERVER_DATE_FORMAT);
    }

    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        created_by: user.user,
        updated_by: user.user,
        monitoring_visit_id: selectedRowData?.id,
        siv_report: { step_one: { clinical_trails: clonedObj } }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange || isSivReportCopyOverrideData) {
        if (isUpdate) {
          if (
            clinicalTrialData.siv_report_protocol_version !== null &&
            clinicalTrialData.siv_report_protocol_review !== null &&
            clinicalTrialData.siv_report_study_objectives !== null &&
            clinicalTrialData.siv_report_inclusion_exclusion !== null &&
            clinicalTrialData.siv_report_soa !== null &&
            clinicalTrialData.siv_report_enrollment_procedure !== null &&
            clinicalTrialData.siv_report_lab_procedure !== null &&
            clinicalTrialData.siv_report_ip_da !== null &&
            clinicalTrialData.siv_report_protocol_deviation !== null &&
            clinicalTrialData.siv_report_other_procedures !== null
          ) {
            await sendRequest('update_siv_report', options);
            getSivReportData('clinicalTrialDetails', false);
            setIsChange('Step1', 'clinicalTrialDetails', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
            setConfirmExitValue(dispatch, false);
            if (isPublished) {
              SignatureBreaking();
            }
          } else {
            setIsSubmit(false);
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
        if (!isUpdate) {
          if (
            clinicalTrialData.siv_report_protocol_version !== null &&
            clinicalTrialData.siv_report_protocol_review !== null &&
            clinicalTrialData.siv_report_study_objectives !== null &&
            clinicalTrialData.siv_report_inclusion_exclusion !== null &&
            clinicalTrialData.siv_report_study_design_timelines !== null &&
            clinicalTrialData.siv_report_soa !== null &&
            clinicalTrialData.siv_report_enrollment_procedure !== null &&
            clinicalTrialData.siv_report_lab_procedure !== null &&
            clinicalTrialData.siv_report_ip_da !== null &&
            clinicalTrialData.siv_report_protocol_deviation !== null &&
            clinicalTrialData.siv_report_other_procedures !== null
          ) {
            await sendRequest('create_siv_report', options);
            setIsChange('Step1', 'clinicalTrialDetails', false);
            getSivReportData('clinicalTrialDetails', true);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
            dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, clinicalTrialDetails: true }));
            setConfirmExitValue(dispatch, false);
          } else {
            setIsSubmit(false);
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
      } else {
        setIsSubmit(false);
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      }
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, clinicalTrialDetails: true }));
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
  };

  const handleCheckBox = (e: any) => {
    const data = e.target.checked ? 'Y' : 'N';
    updateClinicalData({
      ...clinicalTrialData,
      [e.target.name as keyof ISIVReportClinicalTrialData]: data
    });
    dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, clinicalTrialDetails: false }));
    setConfirmExitValue(dispatch, true);
  };
  const perDisable = checkPermission('update_siv_report');
  const perDisableQuery = checkPermission('view_queries_siv_report');

  /**
   * Query menus code start
   */
  const {
    contextMenu,
    setContextMenu,
    queryKeys,
    setQueryKeys,
    checkListQueries,
    raisedQueries,
    totalFieldQueries,
    totalSectionQueries,
    fieldQueries,
    getSivReportQueries,
    raisedSectionQueries,
    report_id: reportId,
    setReport_id: setReportId,
    queryType,
    setQueryType,
    latestSecQueryRaisedBy
  } = useQueryMenus('SIV REPORT');

  useEffect(() => {
    setReportId(sivReportSavedId);
  }, [sivReportSavedId]);

  useEffect(() => {
    setRefreshKey(refreshKey + 1);
  }, [clinicalTrialData.siv_visit_date]);

  const handleContextMenu = (event: React.MouseEvent, checklistItem: keyof ISIVReportClinicalTrialData) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null &&
        (checkPermission('view_queries_siv_report') ||
          checkPermission('view_audit_siv_report') ||
          checkPermission('raise_query_siv_report'))
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4
          }
        : null
    );

    const sectionFieldNames: string[] = [];
    Object.keys(checkListQueries.clinical_trails).forEach((obj: any) => {
      sectionFieldNames.push(checkListQueries.clinical_trails[obj].report_field_name);
    });

    const newObj = {
      ...checkListQueries.clinical_trails[checklistItem],
      id: sivReportSavedId,
      section_key: 'clinical_trails',
      report_field_value: clinicalTrialData[checklistItem],
      section_field_names: sectionFieldNames,
      is_all_field_queries: true
    };
    setQueryKeys(newObj);
  };
  const [openViewQuery, setOpenViewQuery] = useState(false);
  const viewNotes = (checklistItem: keyof ISIVReportClinicalTrialData, isAllFieldQueries = false) => {
    let newObj: any = {};
    if (isAllFieldQueries) {
      const sectionFieldNames: string[] = [];
      Object.keys(checkListQueries.clinical_trails).forEach((obj: any) => {
        sectionFieldNames.push(checkListQueries.clinical_trails[obj].report_field_name);
      });
      newObj = {
        ...checkListQueries.clinical_trails[checklistItem],
        id: sivReportSavedId,
        section_key: 'clinical_trails',
        section_field_names: sectionFieldNames,
        is_all_field_queries: isAllFieldQueries
      };
    } else {
      newObj = {
        ...checkListQueries.clinical_trails[checklistItem],
        id: sivReportSavedId,
        section_key: 'clinical_trails',
        report_field_value: clinicalTrialData[checklistItem],
        is_all_field_queries: isAllFieldQueries
      };
    }

    setQueryKeys(newObj);
    setOpenViewQuery(true);
    setQueryType('ALL');
  };

  useEffect(() => {
    if (
      clinicalTrialData.siv_checklist_protocol_version_num == undefined ||
      clinicalTrialData.siv_checklist_protocol_version_num == null ||
      clinicalTrialData.siv_checklist_protocol_version_num.toString() == ''
    ) {
      setProtocolVersion('x.xx');
    } else {
      setProtocolVersion(parseFloat(clinicalTrialData.siv_checklist_protocol_version_num.toString()).toFixed(1));
    }
  }, [clinicalTrialData]);

  /**
   * Query menus code end
   */
  return (
    <>
      <Loader />
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          {raisedSectionQueries.includes(sectionNames.clinical_trail_details) &&
            sectionNames.clinical_trail_details in latestSecQueryRaisedBy &&
            SectionQueryIndication(
              latestSecQueryRaisedBy,
              sectionNames.clinical_trail_details,
              viewNotes,
              'siv_report_protocol_version'
            )}
          <Grid md={12}>
            <Grid container spacing={2}>
              <Grid item>
                <Typography sx={{ fontSize: '16px' }}>
                  {reportClinicalTrailDetails.label29}
                  {':'}
                  <span style={{ marginLeft: '5px' }}>
                    {checkedInStartDate
                      ? getPreferredDateInLocal(checkedInStartDate)
                      : clinicalTrialData.siv_visit_date}{' '}
                  </span>
                </Typography>
              </Grid>
            </Grid>
            <h4 style={{ marginBottom: '0px' }}>{reportClinicalTrailDetails.header1}</h4>
            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_protocol_version');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9} className="alignCenterRow">
                {reportClinicalTrailDetails.label1} {protocolVersion} <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_protocol_version"
                      value={clinicalTrialData.siv_report_protocol_version}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={handleClinicalTrialData}
                    >
                      <FormControlLabel
                        disabled={!perDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_protocol_version ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!perDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_protocol_version ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    className={`grey-btn${
                      raisedQueries.includes('siv_report_protocol_version') ||
                      raisedSectionQueries.includes(sectionNames.clinical_trail_details)
                        ? ' danger-link'
                        : ''
                    }`}
                    onClick={() => viewNotes('siv_report_protocol_version')}
                    disabled={!perDisableQuery}
                    title="Query"
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input" />
              </Grid>
            </Grid>

            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_protocol_review');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9}>
                {reportClinicalTrailDetails.label2}? <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_protocol_review"
                      value={clinicalTrialData.siv_report_protocol_review}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={handleClinicalTrialData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_protocol_review ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="Yes"
                      />

                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_protocol_review ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    className={`grey-btn${raisedQueries.includes('siv_report_protocol_review') ? ' danger-link' : ''}`}
                    onClick={() => viewNotes('siv_report_protocol_review')}
                    disabled={!perDisableQuery}
                    title="Query"
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_protocol_review_comm"
                    key={`siv_report_protocol_review_comm-${refreshKey}`}
                    error={mandatory['siv_report_protocol_review']}
                    helperText={mandatory['siv_report_protocol_review'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    defaultValue={clinicalTrialData.siv_report_protocol_review_comm || ''}
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onBlur={handleClinicalTrialData}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_study_objectives');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9} className="alignCenterRow">
                {reportClinicalTrailDetails.label3} <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_study_objectives"
                      value={clinicalTrialData.siv_report_study_objectives}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={handleClinicalTrialData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_study_objectives ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_study_objectives ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    className={`grey-btn${raisedQueries.includes('siv_report_study_objectives') ? ' danger-link' : ''}`}
                    onClick={() => viewNotes('siv_report_study_objectives')}
                    disabled={!perDisableQuery}
                    title="Query"
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_study_objectives_comm"
                    key={`siv_report_study_objectives_comm-${refreshKey}`}
                    defaultValue={clinicalTrialData.siv_report_study_objectives_comm || ''}
                    onBlur={handleClinicalTrialData}
                    error={mandatory['siv_report_study_objectives']}
                    helperText={mandatory['siv_report_study_objectives'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_inclusion_exclusion');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9}>
                {' '}
                Inclusion and exclusion criteria live demo of CRF was done during the visit (
                <Link underline="always">Inclusion and exclusion CRF</Link>) <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_inclusion_exclusion"
                      value={clinicalTrialData.siv_report_inclusion_exclusion}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={handleClinicalTrialData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={
                          <Radio
                            sx={{
                              color:
                                isSubmit && !clinicalTrialData.siv_report_inclusion_exclusion ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={
                          <Radio
                            sx={{
                              color:
                                isSubmit && !clinicalTrialData.siv_report_inclusion_exclusion ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    className={`grey-btn${
                      raisedQueries.includes('siv_report_inclusion_exclusion') ? ' danger-link' : ''
                    }`}
                    onClick={() => viewNotes('siv_report_inclusion_exclusion')}
                    disabled={!perDisableQuery}
                    title="Query"
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_inclusion_exclusion_comm"
                    key={`siv_report_inclusion_exclusion_comm-${refreshKey}`}
                    defaultValue={clinicalTrialData.siv_report_inclusion_exclusion_comm || ''}
                    onBlur={handleClinicalTrialData}
                    error={mandatory['siv_report_inclusion_exclusion']}
                    helperText={mandatory['siv_report_inclusion_exclusion'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_study_design_timelines');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9} className="alignCenterRow">
                {reportClinicalTrailDetails.label5}
                <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_study_design_timelines"
                      value={clinicalTrialData.siv_report_study_design_timelines}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={handleClinicalTrialData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={
                          <Radio
                            sx={{
                              color:
                                isSubmit && !clinicalTrialData.siv_report_study_design_timelines ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={
                          <Radio
                            sx={{
                              color:
                                isSubmit && !clinicalTrialData.siv_report_study_design_timelines ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    className={`grey-btn${
                      raisedQueries.includes('siv_report_study_design_timelines') ? ' danger-link' : ''
                    }`}
                    onClick={() => viewNotes('siv_report_study_design_timelines')}
                    disabled={!perDisableQuery}
                    title="Query"
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_study_design_timelines_comm"
                    key={`siv_report_study_design_timelines_comm-${refreshKey}`}
                    defaultValue={clinicalTrialData.siv_report_study_design_timelines_comm || ''}
                    onBlur={handleClinicalTrialData}
                    error={mandatory['siv_report_study_design_timelines']}
                    helperText={mandatory['siv_report_study_design_timelines'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <h4 style={{ marginBottom: '0px' }}>{reportClinicalTrailDetails.header2}</h4>
            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_soa');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9} className="alignCenterRow">
                Schedule of assessments reviewed with site staff (<Link underline="always">SOA calendar</Link>){' '}
                <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_soa"
                      value={clinicalTrialData.siv_report_soa}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={handleClinicalTrialData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_soa ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_soa ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={() => viewNotes('siv_report_soa')}
                    className={`grey-btn${raisedQueries.includes('siv_report_soa') ? ' danger-link' : ''}`}
                    disabled={!perDisableQuery}
                    title="Query"
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_soa_comm"
                    key={`siv_report_soa_comm-${refreshKey}`}
                    defaultValue={clinicalTrialData.siv_report_soa_comm || ''}
                    onBlur={handleClinicalTrialData}
                    error={mandatory['siv_report_soa']}
                    helperText={mandatory['siv_report_soa'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_enrollment_procedure');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9}>
                Screening and enrollment procedures reviewed (
                <Link underline="always">IRT manual and screening/ enrollment log</Link>){' '}
                <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_enrollment_procedure"
                      value={clinicalTrialData.siv_report_enrollment_procedure}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={handleClinicalTrialData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={
                          <Radio
                            sx={{
                              color:
                                isSubmit && !clinicalTrialData.siv_report_enrollment_procedure ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={
                          <Radio
                            sx={{
                              color:
                                isSubmit && !clinicalTrialData.siv_report_enrollment_procedure ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    className={`grey-btn${
                      raisedQueries.includes('siv_report_enrollment_procedure') ? ' danger-link' : ''
                    }`}
                    disabled={!perDisableQuery}
                    onClick={() => viewNotes('siv_report_enrollment_procedure')}
                    title="Query"
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_enrollment_procedure_comm"
                    key={`siv_report_enrollment_procedure_comm-${refreshKey}`}
                    defaultValue={clinicalTrialData.siv_report_enrollment_procedure_comm || ''}
                    onBlur={handleClinicalTrialData}
                    error={mandatory['siv_report_enrollment_procedure']}
                    helperText={mandatory['siv_report_enrollment_procedure'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_lab_procedure');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9}>
                Specimens/ samples to be obtained and frequency (<Link underline="always">lab procedures</Link>
                ) reviewed <br />- Laboratory tour during site visit
                <br />- Kits and current inventory reviewed <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_lab_procedure"
                      value={clinicalTrialData.siv_report_lab_procedure}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      onChange={handleClinicalTrialData}
                    >
                      <FormControlLabel
                        disabled={!perDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_lab_procedure ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_lab_procedure ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={() => viewNotes('siv_report_lab_procedure')}
                    disabled={!perDisableQuery}
                    title="Query"
                    className={`grey-btn${raisedQueries.includes('siv_report_lab_procedure') ? ' danger-link' : ''}`}
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_lab_procedure_comm"
                    key={`siv_report_lab_procedure_comm-${refreshKey}`}
                    defaultValue={clinicalTrialData.siv_report_lab_procedure_comm || ''}
                    onBlur={handleClinicalTrialData}
                    error={mandatory['siv_report_lab_procedure']}
                    helperText={mandatory['siv_report_lab_procedure'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_ip_da');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9}>
                Investigational Product and Drug administration procedures (
                <Link underline="always">
                  Pharmacy procedures, drug accountability log, patient diary, drug destruction procedures
                </Link>
                ) <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_ip_da"
                      value={clinicalTrialData.siv_report_ip_da}
                      row
                      onChange={handleClinicalTrialData}
                      aria-labelledby="demo-row-radio-buttons-group-label"
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_ip_da ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={
                          <Radio
                            sx={{
                              color: isSubmit && !clinicalTrialData.siv_report_ip_da ? pink[800] : 'default'
                            }}
                          />
                        }
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={() => viewNotes('siv_report_ip_da')}
                    disabled={!perDisableQuery}
                    title="Query"
                    className={`grey-btn${raisedQueries.includes('siv_report_ip_da') ? ' danger-link' : ''}`}
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_ip_da_comm"
                    key={`siv_report_ip_da_comm-${refreshKey}`}
                    defaultValue={clinicalTrialData.siv_report_ip_da_comm || ''}
                    onBlur={handleClinicalTrialData}
                    error={mandatory['siv_report_ip_da']}
                    helperText={mandatory['siv_report_ip_da'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <h4 style={{ marginBottom: '8px' }}> {reportClinicalTrailDetails.header3}</h4>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label10}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_ip_intact}
                      name="siv_report_ip_intact"
                      checked={clinicalTrialData.siv_report_ip_intact === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label11}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_ip_secure}
                      name="siv_report_ip_secure"
                      checked={clinicalTrialData.siv_report_ip_secure === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label12}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_ip_storage_csp}
                      name="siv_report_ip_storage_csp"
                      checked={clinicalTrialData.siv_report_ip_storage_csp === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label13}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_ip_temp}
                      name="siv_report_ip_temp"
                      checked={clinicalTrialData.siv_report_ip_temp === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label14}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_refrigerator_callibration}
                      name="siv_report_refrigerator_callibration"
                      checked={clinicalTrialData.siv_report_refrigerator_callibration === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label15}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_refrigerator_notification}
                      name="siv_report_refrigerator_notification"
                      checked={clinicalTrialData.siv_report_refrigerator_notification === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label16}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_pharmacy_binder}
                      name="siv_report_pharmacy_binder"
                      checked={clinicalTrialData.siv_report_pharmacy_binder === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label17}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_pharmacist_training}
                      name="siv_report_pharmacist_training"
                      checked={clinicalTrialData.siv_report_pharmacist_training === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label18}?
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_irt_access}
                      name="siv_report_irt_access"
                      checked={clinicalTrialData.siv_report_irt_access === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label20}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_pharmacist_da_log}
                      name="siv_report_pharmacist_da_log"
                      checked={clinicalTrialData.siv_report_pharmacist_da_log === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label21}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_ip_handling_subject}
                      name="siv_report_ip_handling_subject"
                      checked={clinicalTrialData.siv_report_ip_handling_subject === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label22}?
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_report_ip_compliants}
                      name="siv_report_report_ip_compliants"
                      checked={clinicalTrialData.siv_report_report_ip_compliants === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label23}
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_ip_return}
                      name="siv_report_ip_return"
                      checked={clinicalTrialData.siv_report_ip_return === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label24}?
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_ip_destruction_site}
                      name="siv_report_ip_destruction_site"
                      checked={clinicalTrialData.siv_report_ip_destruction_site === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label25}?
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_emergency_unblinding}
                      name="siv_report_emergency_unblinding"
                      checked={clinicalTrialData.siv_report_emergency_unblinding === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container columnSpacing={5.5}>
              <Grid item md={11} className="alignCenterRow">
                {reportClinicalTrailDetails.label26}?
              </Grid>
              <Grid item md={1}>
                <FormControl>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label=""
                      value={clinicalTrialData.siv_report_maintain_blinding}
                      name="siv_report_maintain_blinding"
                      checked={clinicalTrialData.siv_report_maintain_blinding === 'Y' ? true : false}
                      onChange={handleCheckBox}
                      disabled={!perDisable || saveDisable || !checkedInStartDate}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_protocol_deviation');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9} className="alignCenterRow">
                Procedure for recording and reporting protocol deviations (
                <Link underline="always">Protocol deviations CRF</Link>)<span style={{ color: 'red' }}> *</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_protocol_deviation"
                      value={clinicalTrialData.siv_report_protocol_deviation}
                      row
                      onChange={handleClinicalTrialData}
                      aria-labelledby="demo-row-radio-buttons-group-label"
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={() => viewNotes('siv_report_protocol_deviation')}
                    disabled={!perDisableQuery}
                    title="Query"
                    className={`grey-btn${
                      raisedQueries.includes('siv_report_protocol_deviation') ? ' danger-link' : ''
                    }`}
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_protocol_deviation_comm"
                    key={`siv_report_protocol_deviation_comm-${refreshKey}`}
                    defaultValue={clinicalTrialData.siv_report_protocol_deviation_comm || ''}
                    onBlur={handleClinicalTrialData}
                    error={mandatory['siv_report_protocol_deviation']}
                    helperText={mandatory['siv_report_study_objectives'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_other_procedures');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9} className="alignCenterRow">
                {reportClinicalTrailDetails.label28} <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      name="siv_report_other_procedures"
                      value={clinicalTrialData.siv_report_other_procedures}
                      row
                      onChange={handleClinicalTrialData}
                      aria-labelledby="demo-row-radio-buttons-group-label"
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={() => viewNotes('siv_report_other_procedures')}
                    disabled={!perDisableQuery}
                    title="Query"
                    className={`grey-btn${raisedQueries.includes('siv_report_other_procedures') ? ' danger-link' : ''}`}
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_other_procedures_comm"
                    key={`siv_report_other_procedures_comm-${refreshKey}`}
                    defaultValue={clinicalTrialData.siv_report_other_procedures_comm || ''}
                    onBlur={handleClinicalTrialData}
                    error={mandatory['siv_report_other_procedures']}
                    helperText={mandatory['siv_report_study_objectives'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        {checkPermission('update_siv_report') ? (
          <Grid md={12} display="flex" justifyContent="flex-end">
            <Stack spacing={2} direction="row">
              {isDisable ? (
                <Button
                  onClick={updateClinicalTrialData}
                  variant="text"
                  disabled={saveButtonDisable.clinicalTrialDetails || !checkedInStartDate}
                >
                  SAVE
                </Button>
              ) : (
                ''
              )}
            </Stack>
          </Grid>
        ) : (
          ''
        )}
        <QueryMenus
          totalFieldQueries={totalFieldQueries}
          totalSectionQueries={totalSectionQueries}
          contextMenu={contextMenu}
          setContextMenu={setContextMenu}
          queryKeys={queryKeys}
          fieldQueries={fieldQueries}
          getSivReportQueries={getSivReportQueries}
          report_id={reportId}
          checkListQueries={checkListQueries}
          queryType={queryType}
          setQueryType={setQueryType}
          isSQSivQueries
        />
        <ViewQuery
          totalFieldQueries={totalFieldQueries}
          totalSectionQueries={totalSectionQueries}
          open={openViewQuery}
          setOpen={setOpenViewQuery}
          queryKeys={queryKeys}
          queryType={queryType}
          fieldQueries={fieldQueries}
          getSivReportQueries={getSivReportQueries}
          setQueryType={setQueryType}
          report_id={reportId}
          isSQSivQueries
        />
      </Grid>
    </>
  );
};

export default ClinicalTrialDetails;
